import {all, call} from 'redux-saga/effects';
import axios from 'axios';

import user from './user';
import qna from './qna';
import analytics from './analytics';
import review from './review';
import brand from './brand';
import admin from './admin';
import order from './order';
import product from './product';
import log from './log';
import sample from './sample';
import design from './design';
import pgInfo from './pgInfo';
import setting from './setting';

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_API_BASE_URL : process.env.REACT_APP_REAL_API_BASE_URL;

// 인터셉터 설정
axios.interceptors.response.use(
  response => {
    if (response.headers['access-token'] != null) {
      localStorage.setItem('accessToken', response.headers['access-token']);

      if (response.headers['refresh-token'] != null) {
        localStorage.setItem('refreshToken', response.headers['refresh-token']);
      }
    }

    return response;
  },
  error => {
    return Promise.reject(error);
  },
);

// jwt 토큰 파싱
export const parseJwt = token => {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Invalid token:', e);
    return null;
  }
};

// 현재시간 unix timestamp
export const getUnixTimestamp = Math.floor(Date.now() / 1000);

export default function* rootSaga() {
  yield all([call(user), call(qna), call(analytics), call(review), call(brand), call(admin), call(order), call(product), call(log), call(sample), call(design), call(pgInfo), call(setting)]);
}
